import React from 'react';
import { Button, IconButton } from '@guestyci/arc';
import t from '@guestyci/localize/t.macro';
import { CircleHelp } from '@guestyci/icons/system';
import { useBreakpoint } from '../../utils/useBreakpoint';

const HELP_EMAIL = 'mailto:cantlogin@guesty.com';

const HelpButton = () => {
  const isDesktop = useBreakpoint('md');

  const handleClick = () => {
    window.location.href = HELP_EMAIL;
  };

  if (isDesktop) {
    return (
      <Button
        variant="secondary"
        size="sm"
        icon={CircleHelp}
        onClick={handleClick}
      >
        {t('Need help?')}
      </Button>
    );
  }

  return (
    <IconButton
      variant="outline"
      size="sm"
      onClick={handleClick}
      aria-label={t('Need help?')}
      className="gst-rounded-md"
    >
      <CircleHelp />
    </IconButton>
  );
};

export default HelpButton;
